// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"6d9e4353","411":"ce7e9a9c","579":"0b2aafce"}[chunkId] + ".chunk.js";
};